import axios from "axios";
import doToast from "components/toast/doToast";
import Cookies from "js-cookie";
import { vasClient } from "lib/utils/client";
import { useMutation } from "react-query";

const baseUrl = process.env.REACT_APP_BASE_URL;
// const baseUrlNew = process.env.REACT_APP_VAS_BASE_URL;
const token = Cookies.get("token");

export const userLogin = async body => {
  return await vasClient.post("/auth/signin", body);
};

export const createUser = async body => {
  return await vasClient.post("/user", body);
};

export const updateUser = async ({ id, body }) => {
  return await vasClient.patch(`/user/${id}`, body);
};

export const getUsers = async () => {
  return await vasClient.get("/user");
};

export const resetPassword = async payload => {
  const url = `${baseUrl}/api/authentication/change_password`;
  const res = await axios.post(url, payload, { headers: { Authorization: `Bearer ${token}` } });

  return res.data;
};

export const useUpdateUSer = id => {
  const patchUser = body => vasClient.patch(`/user/${id}`, body);

  const mutation = useMutation({
    mutationKey: ["updateUser"],
    mutationFn: patchUser
  });

  const updateUser = async body => {
    try {
      const data = await mutation.mutateAsync(body);
      doToast("Your password has been changed successfully", "success");
      console.log({ data });
      return data;
    } catch (error) {
      doToast(error?.response?.data?.message, "success");
      return error;
    }
  };

  return {
    updateUser,
    ...mutation
  };
};

export const getRoles = async () => {
  return await vasClient.get("/auth/role");
};
